const preventZoom = (event: Event) => {
  event.preventDefault()
}

const preventMultiTouchZoom = (event: TouchEvent) => {
  if (event.touches.length > 1) {
    event.preventDefault()
  }
}

export default defineNuxtPlugin(() => {
  const isTouchDevice =
    window.matchMedia('(pointer: coarse)').matches ||
    window.navigator.maxTouchPoints > 1

  if (!isTouchDevice) return

  document.addEventListener('gesturestart', preventZoom, { passive: false })
  document.addEventListener('gesturechange', preventZoom, { passive: false })
  document.addEventListener('gestureend', preventZoom, { passive: false })
  document.addEventListener('touchmove', preventMultiTouchZoom, {
    passive: false,
  })
})
